var map = {
  "./osmTagToNameMapping-it.messages.ts": [
    "90268",
    [
      6586
    ]
  ],
  "./osmTagToNameMapping-pl.messages.ts": [
    "70383",
    [
      3323
    ]
  ],
  "./osmTagToNameMapping-hu.messages.ts": [
    "29222",
    [
      4164
    ]
  ],
  "./osmTagToNameMapping-de.messages.ts": [
    "46066",
    [
      8032
    ]
  ],
  "./osmTagToNameMapping-sk.messages.ts": [
    "22665",
    [
      9049
    ]
  ],
  "./osmTagToNameMapping-en.messages.ts": [
    "9530",
    [
      3512
    ]
  ],
  "./osmTagToNameMapping-cs.messages.ts": [
    "70225",
    [
      9281
    ]
  ],
  "./osmTagToNameMapping-sl.messages.ts": [
    "43486",
    [
      2896
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 85731;
module.exports = __rspack_async_context;
